import React, { useState } from "react";
import ImagePreview from "../../components/Image/ImagePreview";
import Modal from "../../components/Modal/Modal";
import ImageUpload from "../../components/Image/ImageUpload";
import { toast } from "react-toastify";
import { eventsUploadImages } from "../../services/EventService";
import { useLocation } from "react-router-dom";
import { injectModels } from "../../redux/injectModels";
import { handleConsoleError } from "../../utils/common-methods";

const EventCoverPicture = (props) => {
  const [previewImageURL, setPreviewImageURL] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const location = useLocation();
  const { id } = location.state || {};

  const openCoverModal = () => {
    setPreviewImageURL(props?.eventData?.coverPicWideUrl || "");
    openModal();
  };

  const handleImageUpload = async (file) => {
    props.application.setLoading(true);
    const formData = new FormData();
    formData.append("CoverPicWide", file.get("image"));
    formData.append("CoverPicSquare", file.get("image"));
    formData.append("Id", id === undefined ? props?.eventData?.id : id);
    try {
      const response = await eventsUploadImages(formData);
      if (response?.isSuccess) {
        const updatedImageUrl = response?.data?.completeURLOfCoverPicWide;
        props.setEventData((prevData) => ({
          ...prevData,
          coverPicWideUrl: updatedImageUrl,
          coverPicSquareUrl: response?.data?.completeURLOfCoverPicSquare,
        }));
        closeModal();
        toast.success(response?.message);
        props.application.setLoading(false);
      }
    } catch (error) {
        props.application.setLoading(false);
     const message= handleConsoleError(error);
    
      toast.error(error?.message|| message);
    }
  };

  return (
    <React.Fragment>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <ImageUpload
          imageURL={previewImageURL}
          onUpload={handleImageUpload}
          maxSize={4 * 1024 * 1024}
          validTypes={["image/png", "image/gif", "image/jpeg"]}
        />
      </Modal>
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <h2>Let's add a cover picture to showcase your event</h2>
        <br />
        <span
          onClick={openCoverModal}
          className="btn btn-primary"
          style={{ cursor: "pointer", padding: "10px 20px", fontSize: "16px" }}
        >
          <i className="fa fa-arrow-up" style={{ marginRight: "8px" }}></i>
          Upload cover picture
        </span>
        <div
          className="row justify-content-center"
          style={{ marginTop: "20px" }}
        >
          <div className="col-lg-6 col-sm-12">
            <div className="Pictures-add">
              <div
                className="Pictures-add1"
                style={{ textAlign: "center", marginBottom: "20px" }}
              >
                <h6>Wide view</h6>
                <ImagePreview
                  src={props?.eventData?.coverPicWideUrl}
                  width="300px"
                  height="200px"
                  style={{
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </div>

              <div className="Pictures-add1" style={{ textAlign: "center" }}>
                <h6>Square view</h6>
                <ImagePreview
                  src={props?.eventData?.coverPicSquareUrl}
                  width="200px"
                  height="200px"
                  style={{
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default injectModels(["application"])(EventCoverPicture);
